import * as yup from "yup";

export const leaveLogSchema = yup.object().shape({
    startDate: yup.date().required('Start date is required'),
    endDate: yup
      .date()
      .required('End date is required')
      .min(yup.ref('startDate'), 'End date cannot be before start date'),
  });